export default __webpack_public_path__ + "static/media/envfooter.1037fba0.svg";